var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationsBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 57.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#263d50;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xC9rtes\\xEDt\\xE9sek"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,38l6.85,5.45v3H8.22v-3l6.85-5.49V25.26A16,16,0,0,1,27.91,9.61a15.86,15.86,0,0,1,6.24,0A15.94,15.94,0,0,1,47,25.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.08,49.79c0,.12,0,.25,0,.37a6.07,6.07,0,1,1-12.13,0c0-.12,0-.25,0-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.15,6.21a3.48,3.48,0,0,0,.42-1.67,3.55,3.55,0,0,0-7.09,0,3.38,3.38,0,0,0,.43,1.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.71,34.42A15.07,15.07,0,0,1,1,23.34,15.06,15.06,0,0,1,5.71,12.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.29,12.45A15.07,15.07,0,0,1,61,23.53a15,15,0,0,1-4.71,11.06"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsBlack);
export default __webpack_public_path__ + "static/media/notificationsBlack.73ee699ee77c8973dd1e6bd918cc8090.svg";
export { ForwardRef as ReactComponent };